/* libs */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

/* components */
import Page from "../../shared/Page";
import Header from "./Header";
import Form from "./Form";
import Loader from "../../ui/Loader";

/* helpers */
import * as globalActions from "../../../actions/globalActions";
import * as themesActions from "../../../actions/themesActions";
import * as pagesActions from "../../../actions/pagesActions";
import * as experiencesActions from "../../../actions/experiencesActions";

class ExperienceNavigation extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loaded: false,
		};
	}

	componentDidMount() {
		const { themesActions, pagesActions, experiencesActions, match } = this.props;
		const { expId, appKey } = match.params;
		themesActions.getThemes(appKey);
		pagesActions.loadPages(expId);
		experiencesActions.loadExperienceNavigation(expId, this.navigationLoaded);
	}

	navigationLoaded = () => {
		this.setState({ loaded: true });
	};

	onSubmit = (values, submitHandler) => {
		const { experiencesActions, match } = this.props;
		const { expId } = match.params;
		experiencesActions.editExperienceNavigation(expId, values, submitHandler);
	};

	render() {
		const { themes, pages, navigation } = this.props;
		const { loaded } = this.state;

		return (
			<Page>
				<div className="ta-center">
					<div className="sortable">
						<Header title="Experience Navigation" itemName="Navigation Item" />
						{navigation && loaded ? (
							<Form initialValues={navigation} onSubmit={this.onSubmit} themes={themes} pages={pages} />
						) : (
							<Loader />
						)}
					</div>
				</div>
			</Page>
		);
	}
}

ExperienceNavigation.propTypes = {
	match: PropTypes.object,
	themes: PropTypes.array,
	globalActions: PropTypes.object,
	themesActions: PropTypes.object,
	pagesActions: PropTypes.object,
	experiencesActions: PropTypes.object,
	history: PropTypes.object,
	navigation: PropTypes.object,
	pages: PropTypes.array,
};

const mapStateToProps = state => ({
	navigation: state.experiences.navigation,
	themes: state.themes.themes,
	pages: state.pages.pages,
});

const mapDispatchToProps = dispatch => ({
	globalActions: bindActionCreators(globalActions, dispatch),
	themesActions: bindActionCreators(themesActions, dispatch),
	pagesActions: bindActionCreators(pagesActions, dispatch),
	experiencesActions: bindActionCreators(experiencesActions, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ExperienceNavigation);
